import { createAction, props } from '@ngrx/store';
import {
  IBillCategory,
  IBillCategoryDetailsResponse,
} from '@dch/billing-business-logic';

export const GET_CATEGORY_DETAILS_REQUEST = 'GET_CATEGORY_DETAILS_REQUEST';
export const GET_CATEGORY_DETAILS_SUCCESS = 'GET_CATEGORY_DETAILS_SUCCESS';
export const GET_CATEGORY_DETAILS_FAILURE = 'GET_CATEGORY_DETAILS_FAILURE';

export const getCategoryDetailsRequest = createAction(
  GET_CATEGORY_DETAILS_REQUEST,
  props<{
    documentReference: string;
    category: IBillCategory;
    billingAccountNumber: string;
  }>()
);
export const getCategoryDetailsSuccess = createAction(
  GET_CATEGORY_DETAILS_SUCCESS,
  props<{
    documentReference: string;
    category: IBillCategory;
    payload: IBillCategoryDetailsResponse;
  }>()
);
export const getCategoryDetailsFailure = createAction(
  GET_CATEGORY_DETAILS_FAILURE,
  props<{ documentReference: string; category: IBillCategory }>()
);
